import VerifyToken from '@/router/middleware/VerifyToken';
import RequiresAuth from '@/router/middleware/RequiresAuth';
import RequiresGuest from '@/router/middleware/RequiresGuest';
import RequiresPermissions from '@/router/middleware/RequiresPermissions';
import config from '@/config';

export const MIDDLEWARE_AUTH = config.routeMiddleware.AUTH;
export const MIDDLEWARE_GUEST = config.routeMiddleware.GUEST;
export const MIDDLEWARE_VERIFY_TOKEN = config.routeMiddleware.VERIFY_TOKEN;
export const MIDDLEWARE_CAN = config.routeMiddleware.CAN;

export default {
  /**
   * List of named route middleware.
   */
  routeMiddleware: {
    [MIDDLEWARE_AUTH]: RequiresAuth,
    [MIDDLEWARE_GUEST]: RequiresGuest,
    [MIDDLEWARE_VERIFY_TOKEN]: VerifyToken,
    [MIDDLEWARE_CAN]: RequiresPermissions,
  },

  /**
   * List of middleware that will executed on afterEach vue-router middleware.
   */
  afterEach: [MIDDLEWARE_VERIFY_TOKEN],
};
